"use client";

import { ThemeProvider, CssBaseline } from "@mui/material";
import { Header, Footer } from "@/components/layout";
import { lightTheme } from "@/themes";
import { usePathname } from "next/navigation";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enGB } from "date-fns/locale";
import type { ProvidersProps } from "@/types";

export const Providers = ({ children }: ProvidersProps) => {
  const pathname = usePathname();
  // The private portal lives at /partner and /partner/*; the public marketing
  // page at /partners is a normal site route and must keep the header/footer.
  const isPortalRoute = pathname === "/partner" || pathname.startsWith("/partner/");
  const isSiteRoute = !pathname.startsWith("/admin") && !isPortalRoute;

  return (
    <ThemeProvider theme={lightTheme}>
      {/* en-GB gives every date picker dd/MM/yyyy and Monday-start calendars,
          rather than the adapter's default US month-first format. */}
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
        <CssBaseline />
        {isSiteRoute && <Header pathname={pathname.slice(1)} />}
        <main>{children}</main>
        {isSiteRoute && <Footer />}
      </LocalizationProvider>
    </ThemeProvider>
  );
};
